import { Box, Button, Stack } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { useSnackbar } from 'notistack';
import React from 'react';

import { useBsimmControlsMappingUpload } from '@/api';
import { UIDropzone } from '@/shared/components';

import { FormValues, validationSchema } from '../duck';

const ConversionByVersion: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { uploadFile, isUploading } = useBsimmControlsMappingUpload();
  const dropzoneRef = React.useRef<{ reset: () => void }>(null);

  const handleSubmit = async (
    values: FormValues,
    { resetForm }: { resetForm: () => void }
  ) => {
    if (!values.file) return;

    try {
      const response = await uploadFile(values.file);
      resetForm();
      dropzoneRef.current?.reset(); // Reset UIDropzone state

      const variant = response?.status;
      let message = '';

      if (variant === 'success') {
        message = response?.message
          ? `File uploaded successfully: ${response.message.created} created, ${response.message.updated} updated`
          : 'File uploaded successfully';
      } else {
        message = response?.message || 'Oops, something went wrong.';
      }

      enqueueSnackbar({
        message,
        variant: variant,
      });
    } catch (uploadError) {
      enqueueSnackbar({
        message: `File upload failed${uploadError instanceof Error ? ': ' + uploadError.message : ''}`,
        variant: 'error',
      });
    }
  };

  return (
    <Formik
      initialValues={{ file: null }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, isSubmitting, values, errors }) => (
        <Form>
          <Stack>
            <Field name="file">
              {() => (
                <UIDropzone
                  ref={dropzoneRef}
                  onDrop={(files: File[]) => {
                    void setFieldValue('file', files[0] || null);
                  }}
                  maxFiles={1}
                  disabled={isSubmitting || isUploading}
                  formName="file"
                  formError={errors.file as string | undefined}
                />
              )}
            </Field>

            <Box
              display="flex"
              justifyContent="flex-end"
              marginTop={2}
            >
              <Button
                variant="contained"
                type="submit"
                disabled={isSubmitting || isUploading || !values.file}
              >
                Submit
              </Button>
            </Box>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default ConversionByVersion;